import { RelatedGuide } from './RelatedGuides';

// Pages du sujet « réponses des invités » : la page centrale (RSVP) et ses
// déclinaisons, une par intention de recherche. Chaque page renvoie aux autres.
export const RSVP_CLUSTER: Record<'rsvp' | 'qr' | 'form' | 'google', RelatedGuide> = {
  rsvp: {
    to: '/rsvp-mariage',
    title: 'RSVP mariage : le guide complet',
    text: 'Le RSVP en ligne, la date limite, les textes à copier et les relances.',
  },
  qr: {
    to: '/qr-code-faire-part-mariage',
    title: 'Un QR code gratuit sur le faire-part',
    text: 'Le créer, le placer, choisir la phrase, et éviter les QR codes qui expirent.',
  },
  form: {
    to: '/formulaire-reponse-mariage',
    title: 'Le formulaire de réponse idéal',
    text: 'Les questions à poser à vos invités, un exemple, et la version carton réponse.',
  },
  google: {
    to: '/google-form-mariage',
    title: 'Google Form pour le mariage',
    text: 'Le pas-à-pas, ses limites, et une alternative plus simple, gratuite aussi.',
  },
};

export const relatedTo = (current: keyof typeof RSVP_CLUSTER) =>
  (Object.keys(RSVP_CLUSTER) as Array<keyof typeof RSVP_CLUSTER>)
    .filter((k) => k !== current)
    .map((k) => RSVP_CLUSTER[k]);
